import { render } from "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=template&id=71318452&scoped=true"
import script from "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=script&lang=js"

import "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=style&index=0&id=71318452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71318452"]])

export default __exports__